import { render, staticRenderFns } from "./AutocompleteForm.vue?vue&type=template&id=55080a9d&"
import script from "./AutocompleteForm.vue?vue&type=script&lang=js&"
export * from "./AutocompleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports